import React, { useState, useEffect } from 'react';

interface LandingPageProps {
  setView: (view: 'guest' | 'join' | 'dashboard') => void;
  openAuthModal: (view: 'login' | 'register') => void;
}

// --- SVG Icons for the new features section ---
const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const PostureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25A2.25 2.25 0 015.25 3h13.5A2.25 2.25 0 0121 5.25z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a.75.75 0 00-.75.75v2.25a.75.75 0 001.5 0V6.75a.75.75 0 00-.75-.75zM9.75 6a.75.75 0 00-.75.75v2.25a.75.75 0 001.5 0V6.75a.75.75 0 00-.75-.75zM6.75 9a.75.75 0 00-.75.75v2.25a.75.75 0 001.5 0v-2.25a.75.75 0 00-.75-.75zM12.75 9a.75.75 0 00-.75.75v2.25a.75.75 0 001.5 0v-2.25a.75.75 0 00-.75-.75zM17.25 9a.75.75 0 00-.75.75v2.25a.75.75 0 001.5 0v-2.25a.75.75 0 00-.75-.75z" />
  </svg>
);
const TrophyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9a9.75 9.75 0 000 1.5h9a9.75 9.75 0 000-1.5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21V11.25m6-3.75h-2.25a.75.75 0 01-.75-.75V3.75c0-.414.336-.75.75-.75h2.25c.414 0 .75.336.75.75v2.25a.75.75 0 01-.75.75zm-15 0h2.25c.414 0 .75-.336.75-.75V3.75a.75.75 0 00-.75-.75H3a.75.75 0 00-.75.75v2.25c0 .414.336.75.75.75z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.25c-3.443 0-6 2.015-6 4.5V18h12v-2.25c0-2.485-2.557-4.5-6-4.5z" />
  </svg>
);
const AccessibilityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5a.75.75 0 01.75.75v13.5a.75.75 0 01-1.5 0V5.25A.75.75 0 0112 4.5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 10.5h12M6 13.5h12M9 4.5a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5H9.75A.75.75 0 019 4.5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 20.25h-7.5a.75.75 0 010-1.5h7.5a.75.75 0 010 1.5z" />
  </svg>
);
const InteractiveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
  </svg>
);
const VoiceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5c-3.14 0-6 2.686-6 6v3c0 3.314 2.86 6 6 6s6-2.686 6-6v-3c0-3.314-2.86-6-6-6zM12 7.5V3" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 14.25c0-2.071-1.679-3.75-3.75-3.75S8.25 12.179 8.25 14.25" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12c0 4.142-3.358 7.5-7.5 7.5S4.5 16.142 4.5 12" />
  </svg>
);
const PlaybackIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
);
const PartnerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.286z" />
    </svg>
);
const OnlineIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A11.953 11.953 0 0012 13.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 003 12c0 .778.099 1.533.284 2.253m0 0c-.578 2.336-2.343 4.29-4.582 5.253" />
    </svg>
);


const FeatureItem: React.FC<{ icon: React.ReactNode; title: string; description: string }> = ({ icon, title, description }) => (
  <div className="text-center">
    <div className="flex justify-center items-center h-20 mb-4">
      {icon}
    </div>
    <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
    <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
  </div>
);


const LandingPage: React.FC<LandingPageProps> = ({ setView, openAuthModal }) => {

  const DynamicText: React.FC = () => {
    const words = ["Faster", "Accurate", "Confident"];
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [reverse, setReverse] = useState(false);

    useEffect(() => {
        if (subIndex === words[index].length + 1 && !reverse) {
            setTimeout(() => setReverse(true), 1000);
            return;
        }
        if (subIndex === 0 && reverse) {
            setReverse(false);
            setIndex((prev) => (prev + 1) % words.length);
            return;
        }
        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (reverse ? -1 : 1));
        }, reverse ? 75 : 150);
        return () => clearTimeout(timeout);
    }, [subIndex, index, reverse]);


    return (
        <span className="animated-gradient font-black">{`${words[index].substring(0, subIndex)}`}</span>
    );
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="text-center py-20 px-4">
        <h1 className="text-5xl md:text-7xl font-extrabold text-gray-800 mb-4 fade-in-up">
          Become a <DynamicText /> Typist.
        </h1>
        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-8 opacity-0 fade-in-up" style={{ animationDelay: '0.3s' }}>
          The fun, interactive typing platform for K-12 students. Master the keyboard with engaging lessons, exciting games, and real-time feedback.
        </p>
        <div className="flex justify-center space-x-4 opacity-0 fade-in-up" style={{ animationDelay: '0.6s' }}>
          <button onClick={() => openAuthModal('register')} className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-transform transform hover:scale-105">
            Get Started for Free
          </button>
          <button onClick={() => setView('guest')} className="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg shadow-md hover:bg-gray-100 transition-transform transform hover:scale-105">
            Try a Demo
          </button>
        </div>
      </section>

      {/* "Why TypeoGO?" Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Why TypeoGO?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="text-blue-500 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <h3 className="text-2xl font-bold mb-2">Engaging Games</h3>
              <p className="text-gray-600">Turn practice into play with our suite of fun typing games like Car Race, Word Burst, and Bubble Pop.</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
               <div className="text-purple-500 mb-4">
                 <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              </div>
              <h3 className="text-2xl font-bold mb-2">Structured Curriculum</h3>
              <p className="text-gray-600">Step-by-step tutorials guide students from home row basics to complex words and punctuation.</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="text-green-500 mb-4">
                 <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
              </div>
              <h3 className="text-2xl font-bold mb-2">Teacher & Parent Tools</h3>
              <p className="text-gray-600">Monitor progress, create custom lessons, manage classes, and keep parents informed with our powerful dashboards.</p>
            </div>
          </div>
        </div>
      </section>

      {/* NEW "Reasons to Start Learning" Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h3 className="text-sm font-bold text-center text-gray-500 uppercase tracking-wider">Inside TypeoGO</h3>
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">All the reasons to start learning<br/>how to type right now</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
            <FeatureItem
              icon={<StarIcon />}
              title="It's a game."
              description="An engaging and interactive experience while you are learning how to type."
            />
            <FeatureItem
              icon={<PostureIcon />}
              title="Proper hand posture guide."
              description="Will show you the correct hand posture on every key as you type."
            />
            <FeatureItem
              icon={<TrophyIcon />}
              title="Levels, Badges and Stars."
              description="All the reasons to keep you going, and build your muscle memory."
            />
            <FeatureItem
              icon={<AccessibilityIcon />}
              title="Accessibility."
              description="TypeoGO is the most accessible typing program available."
            />
            <FeatureItem
              icon={<InteractiveIcon />}
              title="Interactive experience."
              description="A full range of experiences from games, videos and different typing challenges makes learning fun."
            />
            <FeatureItem
              icon={<VoiceIcon />}
              title="Voice over."
              description="Once you turn it on, every word is read out loud as you are typing each word."
            />
             <FeatureItem
              icon={<PlaybackIcon />}
              title="Typing Playback."
              description="You can view your past performances and even play them back."
            />
             <FeatureItem
              icon={<PartnerIcon />}
              title="Trusted Partner."
              description="TypeoGO is designed for education and trusted by schools."
            />
             <FeatureItem
              icon={<OnlineIcon />}
              title="100% Online."
              description="All you need is a keyboard and a web browser."
            />
          </div>
        </div>
      </section>

    </div>
  );
};

export default LandingPage;